export const copyMixin = {
    methods: {
        copy(id) {
            const copyText = document.getElementById(id);
            copyText.select();
            document.execCommand("copy");
        }
    }
};
